/**
 * DevExtreme (ui/tree_list/ui.tree_list.virtual_columns.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var _uiTree_list = require("./ui.tree_list.core");
var _uiTree_list2 = _interopRequireDefault(_uiTree_list);
var _uiGrid_core = require("../grid_core/ui.grid_core.virtual_columns");
var _uiGrid_core2 = _interopRequireDefault(_uiGrid_core);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    }
}
_uiTree_list2.default.registerModule("virtualColumns", _uiGrid_core2.default);



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/tree_list/ui.tree_list.virtual_columns.js
// module id = 1310
// module chunks = 0